import { makeActionCreator } from "redux-toolbelt";
import { useDispatch } from "react-redux";
import { useEmails } from "./state";

const navActionCreator = makeActionCreator.withDefaults({ prefix: "@emails/" });

export const loadEmails = navActionCreator("LOAD_EMAILS");
export const loadEmailsSuccess = navActionCreator("LOAD_EMAILS_SUCCESS");
export const loadEmailsError = navActionCreator("LOAD_EMAILS_ERROR");

export const useLoadEmails = (): ((workspaceId: string, lastEmailId?: string) => void) => {
  const dispatch = useDispatch();
  const { loading, error } = useEmails();
  return (workspaceId: string, lastEmailId?: string) => {
    if (!(loading || error)) {
      dispatch(
        loadEmails({
          workspaceId,
          lastEmailId,
          limit: 100,
        }),
      );
    }
  };
};
